import styled from "styled-components";
import { rem } from "polished";
import { media } from "../components/styled/themeVariables";
import {H1} from "../components/typography/styled/typography";

export const BlogPost = styled.article``;

export const BlogPostTitle = styled(H1)`
  padding-bottom: 0;
`;

export const BlogTitle = styled.h2`
  a {
    text-decoration: none;
    color: ${(props) => props.theme.colors.brandOppositeDark};
  }

  padding-bottom: 10px;
  border-bottom: 1px solid ${(props) => props.theme.colors.brandOppositeDark};
`;

export const PostDate = styled.p`
  color: ${(props) => props.theme.colors.link};
  font-size: ${rem(16)};
  text-align: center;
`;

export const PostBox = styled.div`
  border-bottom: 1px solid ${(props) => props.theme.colors.border};
  border-radius: 5px;
  margin-bottom: ${rem(20)};
  padding: 10px 0 30px;

  ${media.tablet`
     border: 1px solid ${(props) => props.theme.colors.border};
     padding: 40px 50px;
  `}
`;

export const Labels = styled.ul`
  list-style-type: none;
  padding: 0;
  font-size: ${rem(15)};

  li {
    display: inline-block;
    margin-right: 10px;

    a {
      color: ${(props) => props.theme.colors.brandOppositeLight};
      text-decoration: none;
    }

    a:hover {
      text-decoration: underline;
    }
  }
`;

export const MenuBox = styled.div`
  border-bottom: 1px solid ${(props) => props.theme.colors.border};
  margin-bottom: ${rem(20)};
  padding: 10px 0 30px;

  ${media.tablet`
     padding: 40px 0;
     margin: 0 0 20px 50px;
  `}
`;

export const About = styled.div`
  border-top: 1px solid ${(props) => props.theme.colors.border};
  margin: 15px 0;

  p {
    font-size: ${rem(13)};
  }
`;

export const MenuTag = styled.div`
  padding: 5px 0;

  a {
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const TopicTitle = styled.h3`
  a {
    text-decoration: none;
    color: ${(props) => props.theme.colors.brandOppositeDark};
  }

  padding-bottom: 10px;
  border-bottom: 1px solid ${(props) => props.theme.colors.brandOppositeDark};
`;
